import Script from "next/script";
import { useEffect } from "react";
import { useUser } from "@/auth/useUser";

function BirdEatsBugWebSDK() {
  const { user, userMedspa, medspa } = useUser();

  useEffect(() => {
    const beforeUpload = (sessionData) => {
      // Enrich session data with user and medspa information
      // this will be an empty object for clients / anonymous users
      const enrichment = {
        userId: user?.id,
        userEmail: user?.email,
        medspaId: medspa,
        userMedspaId: userMedspa?.id,
      };

      const enrichedSessionData = {
        ...sessionData,
        session: {
          ...sessionData.session,
          // Unfortunatelly, the description field is the best place to store this.
          // Using Zapier, I will extract the JSON and store it in a separate field on the hubspot ticket
          description: `${sessionData.session.description} - JSON:${JSON.stringify(enrichment)}`,
        },
      };
      return enrichedSessionData;
    };

    if (typeof window !== "undefined" && window?.birdeatsbug) {
      const birdeatsbug = window.birdeatsbug;
      birdeatsbug.setOptions({
        user: { email: user?.email },

        // instantReplay is an optional setting... may cause performance implications
        // See https://sdk.birdeatsbug.com/1.67.2/docs/instant-replay.html
        instantReplay: true,
        ui: {
          theme: "light",
          watermark: false,
          defaultButton: false,
          text: {
            previewScreen: {
              title: "Contact Support",
            },
            submitConfirmationScreen: {
              title: "Support request submitted",
              message:
                "Thanks for reporting this to us. A member of the team will investigate this and get back to you.",
              copyLink: "Copy link to your support request",
              copiedLink: "&check; Link copied!",
            },
          },
        },
        hooks: {
          beforeUpload,
        },
      });
    }
  }, [medspa, user?.email, user?.id, userMedspa?.id]);

  return (
    <Script id="bird-eats-bug">
      {`;(function () {
  const birdeatsbug = (window.birdeatsbug = window.birdeatsbug || []);
  if (birdeatsbug.initialize) return;
  if (birdeatsbug.invoked) {
    if (window.console && console.error) {
      console.error("birdeatsbug snippet included twice.");
    }
    return;
  }
  birdeatsbug.invoked = true;
  birdeatsbug.methods = [
    "setOptions",
    "trigger",
    "resumeSession",
    "takeScreenshot",
    "startRecording",
    "stopRecording",
    "stopSession",
    "uploadSession",
    "deleteSession",
  ];
  birdeatsbug.factory = function (method) {
    return function () {
      const args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      birdeatsbug.push(args);
      return birdeatsbug;
    };
  };
  for (let i = 0; i < birdeatsbug.methods.length; i++) {
    const key = birdeatsbug.methods[i];
    birdeatsbug[key] = birdeatsbug.factory(key);
  }
  birdeatsbug.load = function () {
    const script = document.createElement("script");
    script.type = "module";
    script.async = true;
    script.src = "https://sdk.birdeatsbug.com/v2/core.js";
    const mountJsBefore =
      document.getElementsByTagName("script")[0] || document.body.firstChild;
    mountJsBefore.parentNode.insertBefore(script, mountJsBefore);
    const style = document.createElement("link");
    style.rel = "stylesheet";
    style.type = "text/css";
    style.href = "https://sdk.birdeatsbug.com/v2/style.css";
    const mountCssBefore =
      document.querySelector('link[rel="stylesheet"]') || mountJsBefore;
    mountCssBefore.parentNode.insertBefore(style, mountCssBefore);
  };
  birdeatsbug.load();
  window.birdeatsbug.setOptions({
    publicAppId: "cde0dfa3-685d-4450-9da0-88e9dfffc648",
  });
})();
`}
    </Script>
  );
}

export default BirdEatsBugWebSDK;
